module.exports = __webpack_public_path__ + "img/용리단길 맛집.0885c1b4.png";